import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ApolicesClass,
  ClaimsClass,
  ClientsClass,
  ClientsFilterClass,
  FilterApolicesClass,
  FilterClaimsClass,
  filterReceiptsClass,
  ReceiptsClass,
} from '../models/ageas-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { AGEASInsurancePolicyDocument, InsurancePolicyClass } from '../models/insurancesPolicy-class';
import { FilesClass } from '../models/uploads-class';

@Injectable({
  providedIn: 'root',
})
export class AgeasService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  GetPoliciesImportPolicyNumber(PolicyNumber: string): Observable<{ message: string; policies: ApolicesClass[] }> {
    return this.http
      .post<{
        message: string;
        policies: ApolicesClass[];
      }>(`${environment.URLROBOT}/ageas/GetPoliciesImportPolicyNumber/${PolicyNumber}`, null)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  getAgeasPolicyDocuments(insurancePolicyClass: InsurancePolicyClass): Promise<number> {
    return new Promise((resolve, reject) => {
      if (insurancePolicyClass.idCompanie === 2) {
        try {
          insurancePolicyClass.loading = true;
          this.GetPolicyDocuments(insurancePolicyClass.PolicyNumber).subscribe({
            next: (dados: AGEASInsurancePolicyDocument[]) => {
              // Mapear os dados retornados para objetos do tipo FilesClass
              const insurancePolicyFiles: FilesClass[] = dados.map(item => {
                const filesClassItem = new FilesClass();
                // Mapear os campos correspondentes
                filesClassItem.idCompanie = insurancePolicyClass.idCompanie;
                filesClassItem.PolicyNumber = insurancePolicyClass.PolicyNumber;
                filesClassItem.Tabulador = item.type.description;
                filesClassItem.DocumentName = item.documentName;
                filesClassItem.Description = item.documentName;
                filesClassItem.DateStart = new Date(item.date);
                filesClassItem.documentId = item.documentId;
                filesClassItem.FilePath = item.documentId;
                filesClassItem.updated = new Date(item.date);
                filesClassItem.type = 'application/pdf';
                // ... mapear os outros campos necessários

                // Definir VirtualDoc como true
                filesClassItem.VirtualDoc = true;

                // Adicionar o registro à classe insurancePolicyClass
                insurancePolicyClass.insurancePolicyFilesClass.push(filesClassItem);

                return filesClassItem;
              });
              insurancePolicyClass.loading = false;
              resolve(insurancePolicyFiles.length); // Retorna o total de registros adicionados
            },
            error: error => {
              insurancePolicyClass.loading = false;
              reject(error);
            },
          });
        } catch (error) {}
      } else {
        reject();
      }
    });
  }

  AGEASdownload(PolicyNumber: string, DocumentId: string): Observable<any> {
    try {
      if (DocumentId === null || DocumentId.trim() === '') {
        return;
      }

      let dados = {
        PolicyNumber: PolicyNumber,
        DocumentId: DocumentId,
      };

      return this.http.post(`${environment.URLROBOT}/ageas/GetPolicyDocumentsDownload`, dados).pipe(
        catchError(error => {
          console.log(error);
          return throwError(() => error);
        }),
      );
    } catch (error) {
      console.log(error);
    }
  }

  GetPolicyDocuments(policyNumber: string): Observable<AGEASInsurancePolicyDocument[]> {
    let dados = {
      PolicyNumber: policyNumber,
    };
    return this.http
      .post<AGEASInsurancePolicyDocument[]>(`${environment.URLROBOT}/ageas/GetPolicyDocuments`, dados)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetClients(filtro: ClientsFilterClass): Observable<ClientsClass> {
    return this.http.post<ClientsClass>(environment.URLROBOT + `/ageas/GetClients`, filtro).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetPolicies(filtro: FilterApolicesClass): Observable<ApolicesClass> {
    return this.http.post<ApolicesClass>(environment.URLROBOT + `/ageas/GetPolicies`, filtro).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetClaims(filtro: FilterClaimsClass): Observable<ClaimsClass> {
    return this.http.post<ClaimsClass>(environment.URLROBOT + `/ageas/GetClaims`, filtro).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetReceipts(filtro: filterReceiptsClass): Observable<ReceiptsClass> {
    return this.http.post<ReceiptsClass>(environment.URLROBOT + `/ageas/GetReceipts`, filtro).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
